( function () {
	'use strict';

	function RequiredIndicatorsModalController ( logger, $modalInstance ) {
		var self = this;

		function activate () {
			logger.info( 'Required Indicators Modal.' );
		}

		function close () {
			$modalInstance.dismiss();
		}

		self.close = close;

		activate();
	}

	angular
		.module( 'app.observations' )
		.controller( 'RequiredIndicatorsModalController', RequiredIndicatorsModalController );

	RequiredIndicatorsModalController.$inject = [ 'logger', '$modalInstance' ];
} )();
